import { useState, useCallback } from "react";

/**
 * Custom hook: Manage filters state
 */
export const useFilters = (initFilters) => {
  const [filters, setFilters] = useState(initFilters);
  const [showFilters, setShowFilters] = useState(false);

  const activeFilters = Object.values(filters).some((v) => v !== "");

  const clearFilters = useCallback(() => {
    setFilters(initFilters);
  }, [initFilters]);

  return {
    filters,
    setFilters,
    showFilters,
    setShowFilters,
    activeFilters,
    clearFilters,
  };
};

/**
 * Custom hook: Manage pagination
 */
export const usePagination = () => {
  const [page, setPage] = useState(1);

  const resetPage = useCallback(() => {
    setPage(1);
  }, []);

  return {
    page,
    setPage,
    resetPage,
  };
};
